import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import React from "react";

const SiteFooterHeader: React.FC = () => (
    <Box
        alignItems="center"
        display="flex"
        flexDirection={["column", "row"]}
        marginBottom="space80"
        textAlign={["center", "left"]}
    >
        <Text
            as="h2"
            color="colorTextInverse"
            fontSize={["fontSize60", "fontSize90"]}
            fontWeight="fontWeightBold"
            lineHeight={["lineHeight60", "lineHeight90"]}
            marginTop={["space40", "space0"]}
        >
            Need some help?
        </Text>
    </Box>
);

export { SiteFooterHeader };
